export const OrderByValue = {
  ascending: 'asc',
  descending: 'desc'
};

export const TitleOptions = [
  { text: 'Chave da nota', canOrder: false, width: '35%' },
  { text: 'Nota fiscal', canOrder: false, width: '10%' },
  { text: 'Autor', canOrder: false, width: '18%' },
  { text: 'Data de recebimento', canOrder: false, width: '15%' },
  { text: 'Status', canOrder: false, width: '10%' },
];
